import styled from 'styled-components';

import { UserProfileWrapper } from '../../user/UserProfile';
import { UserSubscriptionWrapper } from '../../user/UserSubscription';
import { ContainerWrapper } from '../../user/YoutubeWhitelist';

export const Wrapper = styled.div`
  padding: 27px 48px 0 48px;

  ${UserProfileWrapper}, ${UserSubscriptionWrapper}, ${ContainerWrapper} {
    padding: 0;
    margin: 0 auto 0 0;
    overflow: hidden;

    > * {
      &:first-child {
        margin-top: 32px;
      }
    }
  }
`;
